import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Box, Grid, IconButton } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import SearchableMultiSelect from '../../common/SearchableMultiSelect';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "profile_id", numeric: false, disablePadding: false, label: "Profile", padding: '8px', field: 'profile_id' },
      { id: "email", numeric: false, disablePadding: false, label: "email", padding: '8px', field: 'email' },
      { id: "invoice_id", numeric: false, disablePadding: false, label: "Invoice", padding: '8px', field: 'invoice_id' },
      { id: "item_name", numeric: false, disablePadding: false, label: "Items", padding: '8px', field: 'item_name' },
      { id: "bin_id", numeric: false, disablePadding: false, label: t("Report.Assign.BIN"), padding: '8px', field: 'bin_id' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t("Report.Assign.StockCode"), padding: '8px', field: 'stock_code' },
      { id: "pickup_code", numeric: false, disablePadding: false, label: t("Report.Assign.PUCode"), padding: '8px', field: 'pickup_code' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Assign.Store"), padding: '8px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Assign.Location"), padding: '8px', field: 'name' },
      { id: "stocked_date", numeric: false, disablePadding: false, label:t('Report.Stocked.StockDate'), padding: '8px', field: 'stocked_date' },
      { id: "username", numeric: false, disablePadding: false, label: t("Report.Assign.User"), padding: '8px', field: 'username' }
    ];

    return (
      <TableHead>

        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                {[
                  "deliverytype",
                  "fillid",
                  "prescriptionnumber",
                  "OrderId",
                  "PrescriptionTxnId",
                  "ndccode",
                  "qty",
                  "price",
                  "createdon",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
  root: {
    width: "100%",
    // width: '94.6%'
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  }
  ,
  padding10px: {
    padding: '8px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  }
});

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'stocked_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "stocked_date",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const { t } = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        console.log(storelist,"storelist");
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
      });
    
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });
    TransactionFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
    
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/RetailStockItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        let csvRow = [];
        let Array = [['ID', 'Profile Id', 'Email', 'Invoice Id', 'Items', 'Stock Code', 'Pickup Code', 'Bin Id','Store','Box','Stock Date']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined) {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.profile_id,
                  i.email,
                  i.invoice_id,
                  i.item_name,
                  i.stock_code,
                  i.pickup_code,
                  i.bin_id,
                  i.store,
                  i.box,
                  i.stocked_date? this.convertToTimeZone(i && i.stocked_date) : '',
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "AssignedItemsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
        this.setState({ loader: false });
      })
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['profile_id', 'email'].includes(field)) {
      tablename = 'icustomers';
    }
    if (['name'].includes(field)) {
      tablename = 'products';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === orderBy) {
      order = this.state.order === "asc" ? "desc" : "asc";
    } else if (this.state.order === order) {
      order = "asc";
    } else {
      order = "desc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    console.log(store_ids,"store_ids")
    if (store_ids.length > 0) {
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const { t } = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          //const boxvalues = boxlist;
          this.setState({ chipboxes: [], nboxes: [], boxvalues: boxvalues });
        });
    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }
    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'apis/i-ecom/orders/order/getStockeditems', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            totalRecords: uData && uData.total,
            data: uData && uData.results            
          });
          setTimeout(() => {
            this.setState({
              isDataEmpty: false,
              isButtonDisabled: false,
              loader: false
            })
          }, 5000)
        } else {
          this.setState({
            isDataEmpty: true,
            isButtonDisabled: true,
            loader: false
          })
        }
      });
  }

  exportPDF = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'printAssignedItems', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then((response) => {
        try {
          return response.text()
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        let x = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,top=100,left=145');
        x.document.write(res);
        x.document.close();
        setTimeout(() => {
          x.print();
          x.close();
          this.setState({ loader: false });
        }, 1300)
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.error(error)
      })
  }

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, locale } = this.state;
    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <Box component="div">
          <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
              <SearchableMultiSelect
                label={t("Report.Assign.Store")}
                items={this.state.accountValues || []}
                selectedChips={this.state.chipstores}
                selectedItems={this.state.nstores}
                onChange={this.handleStoreChange}
                onDeleteChip={this.handleDeleteStoreChip}
                onClearAll={this.handleClearAllStores}
                placeholder="Search stores..."
                id="select-multiple-chip-store"
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <SearchableMultiSelect
                label={t("Report.Assign.Box")}
                items={this.state.boxvalues || []}
                selectedChips={this.state.chipboxes}
                selectedItems={this.state.nboxes}
                onChange={this.handleBoxChange}
                onDeleteChip={this.handleDeleteBoxChip}
                onClearAll={this.handleClearAllBoxes}
                placeholder="Search locations..."
                id="select-multiple-chip"
              />
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                <Select
                  value={this.state.dateRangePreset}
                  onChange={this.handleDateRangePresetChange}
                  variant="standard"
                  label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                >
                  <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                  <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                  <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                  <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    keyboard
                    value={this.state.fromdate}
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Assign.FormDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurfrom}
                      />
                    }
                    onChange={this.onFromDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    keyboard
                    value={this.state.todate}
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Assign.ToDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurtodate}
                      />
                    }
                    onChange={this.onToDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
                <TextField
                  id="idsearchtxt"
                  defaultValue=""
                  value={this.state.searchtxt}
                  label={t("Report.Assign.Search")}
                  onChange={this.onSearchChange}
                  variant="standard"
                />
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="single-edit" title={t("Report.Assign.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="single-edit" title={t("Report.Assign.ExportPDFTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        <Divider style={{ marginTop: '10px', height: '5px', borderColor: 'rgba(0, 0, 0, 0.12)', borderStyle: 'solid', borderBottomWidth: '5px' }} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={TransactionFilterObj.sortOrder}
              orderBy={TransactionFilterObj.sortColumn}
              sortId={this.state.sortId}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {!data ?
                (<TableRow>
                  <TableCell colSpan={20} style={{ textAlign: "center", padding: '10px 0px' }}>
                    {this.state.isDataEmpty && t("Report.Assign.NoDataFound")}
                  </TableCell>
                </TableRow>)
                : data.length && data.length > 0 &&
                stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                  .map(n => {
                    return (
                      <TableRow>
                        <TableCell className={classes.padding10px} >{n.profile_id}</TableCell>
                        <TableCell className={classes.padding10px} >{n.email}</TableCell>
                        <TableCell className={classes.padding10px} >{n.invoice_id}</TableCell>
                        <TableCell className={classes.padding10px} >{n.item_name}</TableCell>
                        <TableCell className={classes.padding10px} >{n.bin_id}</TableCell>
                        <TableCell className={classes.padding10px} >{n.stock_code}</TableCell>
                        <TableCell className={classes.padding10px} >{n.pickup_code}</TableCell>
                        <TableCell className={classes.padding10px} >{n.store}</TableCell>
                        <TableCell className={classes.padding10px} >{n.box}</TableCell>
                        <TableCell className={classes.padding10px} >{n.stocked_date ? this.convertToTimeZone(n && n.stocked_date) : ''}</TableCell>
                        <TableCell className={classes.padding10px} >{n.username}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={TransactionFilterObj.pageSize}
            page={TransactionFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/retail-stocked-items/index.js